"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnknownError = void 0;
var genericError_1 = require("./genericError");
/**
 * Ошибка "Неизвестная ошибка". Должна использоваться в исключительных случаях:
 *
 * @example
 * eventEmmitter.on('UncaughtException', () => {
 *  throw new UnknownError({ message: 'Event Emmitter uncaught exception!', domain: 'EventEmmiter#handler' });
 * });
 *
 * @export
 * @class UnknownError
 * @extends {GenericError}
 */
var UnknownError = /** @class */ (function (_super) {
    __extends(UnknownError, _super);
    function UnknownError(_a) {
        var message = _a.message, domain = _a.domain, details = _a.details;
        var _this = _super.call(this, {
            type: 'UnknownError',
            message: message,
            domain: domain,
            details: details,
        }) || this;
        Object.setPrototypeOf(_this, UnknownError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, UnknownError);
        }
        else {
            _this.stack = new Error().stack;
        }
        return _this;
    }
    return UnknownError;
}(genericError_1.GenericError));
exports.UnknownError = UnknownError;
//# sourceMappingURL=unknownError.js.map